import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { CustomAction } from '@nimmsta/ng-commons-lib/data-table';
import {
  DataConnection,
  DataConnectionStatus,
} from '@nimmsta/ng-commons-lib/models';

_('dataconnection.template.activate');
_('dataconnection.template.deactivate');

export class ActivateDeactivateAction extends CustomAction<DataConnection> {
  override getText(item: DataConnection): string {
    if (item.status === DataConnectionStatus.ACTIVE) {
      return 'dataconnection.template.deactivate';
    } else {
      return 'dataconnection.template.activate';
    }
  }
}
